(function($) {
    $(document).ready(function() {
        var loading = $('.image--no-loading').length
        $('.image--no-loading').parent('.card-img').addClass('hide-loader');
        
    });
})(jQuery);
